import { motion } from "framer-motion";
import { Phone, Star, ShieldCheck, Clock } from "lucide-react";
import { IMAGES } from "@/lib/content";
import { CONTACT } from "@/lib/content";

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.12 } }),
};

export default function Hero() {
  const go = (h) => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 pb-16 lg:pt-40 lg:pb-24 hero-grid-bg overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <motion.div custom={0} initial="hidden" animate="show" variants={fade} className="label-caps mb-5">
            Kelowna & The Okanagan · Since Day One
          </motion.div>
          <motion.h1 custom={1} initial="hidden" animate="show" variants={fade}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0F172A] leading-[1.05]">
            Carpets that look<br /><span className="text-[#1A2A5E]">and feel brand new.</span>
          </motion.h1>
          <motion.p custom={2} initial="hidden" animate="show" variants={fade}
            className="mt-6 text-lg text-[#475569] max-w-xl leading-relaxed">
            Deep Clean. Fast Dry. Honest Service. Professional portable steam extraction for homes and
            businesses across Kelowna — residential, commercial and move-out cleaning done right.
          </motion.p>

          <motion.div custom={3} initial="hidden" animate="show" variants={fade} className="mt-8 flex flex-wrap gap-4">
            <button data-testid="hero-book-btn" onClick={() => go("#book")}
              className="bg-[#1A2A5E] text-white font-bold px-8 py-4 rounded-sm hover:bg-[#2B4BB8] transition-colors">
              Get Your Free Quote
            </button>
            <a href={CONTACT.phoneHref} data-testid="hero-call-btn"
              className="inline-flex items-center gap-2 border border-[#1A2A5E] text-[#1A2A5E] font-bold px-8 py-4 rounded-sm hover:bg-white transition-colors">
              <Phone className="w-5 h-5" /> {CONTACT.phone}
            </a>
          </motion.div>

          <motion.div custom={4} initial="hidden" animate="show" variants={fade}
            className="mt-10 flex flex-wrap gap-x-8 gap-y-4 text-sm font-semibold text-[#0F172A]">
            <span className="flex items-center gap-2"><Star className="w-4 h-4 text-[#2B4BB8]" /> 4.6★ · 124 Google Reviews</span>
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#2B4BB8]" /> Satisfaction Guaranteed</span>
            <span className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#2B4BB8]" /> Fast 1–2 Hr Dry Time</span>
          </motion.div>
        </div>

        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }}
          className="relative">
          <div className="relative rounded-sm overflow-hidden shadow-2xl border border-[#E2E8F0]">
            <img src={IMAGES.heroResidential} alt="Freshly cleaned luxury living room carpet" className="w-full h-[420px] lg:h-[520px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-4 sm:left-6 bg-white shadow-xl border border-[#E2E8F0] rounded-sm p-5 w-56 animate-floaty">
            <div className="text-3xl font-display font-extrabold text-[#1A2A5E]">100%</div>
            <div className="text-sm text-[#475569] font-semibold">Satisfaction or we re-clean it free.</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
